import { dataService } from './dataService';

export const api = dataService;
